// extracted by mini-css-extract-plugin
export default {"container":"accordion_container__-uhRl","title":"accordion_title__oFtDo"};